import { render, staticRenderFns } from "./grantPoints.vue?vue&type=template&id=0b1437e6&"
import script from "./grantPoints.vue?vue&type=script&lang=js&"
export * from "./grantPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports